import { render, staticRenderFns } from "./LodgingTabs.vue?vue&type=template&id=8040216a&scoped=true"
import script from "./LodgingTabs.vue?vue&type=script&lang=js"
export * from "./LodgingTabs.vue?vue&type=script&lang=js"
import style0 from "./LodgingTabs.vue?vue&type=style&index=0&id=8040216a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8040216a",
  null
  
)

export default component.exports